module.exports = __webpack_public_path__ + "media/01.a2ff8c3e.mp3";